exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-lists .img-box[data-v-52713463] {\n  padding: 0 15px 5px;\n  width: 100%;\n  min-height: 100px;\n  border-radius: 8px;\n  overflow: hidden;\n}\n.item-lists .img-box[data-v-52713463] img {\n  border-radius: 8px;\n}\n.item-lists .img-box .el-icon-picture[data-v-52713463] {\n  width: 100%;\n  height: 100px;\n  display: block;\n  border-radius: 8px;\n  line-height: 100px;\n  text-align: center;\n}\n", ""]);

// exports
